import React from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import { withAuth } from '@okta/okta-react';
import { Loader, Message } from 'semantic-ui-react';
import PaymentRequestFrame from '../../components/PaymentRequestFrame';
import getSignatureQuery from '../../queries/getSignature';

export class PaymentContainer extends React.Component {
  static propTypes = {
    paymentRequest: PropTypes.shape({
      amount: PropTypes.number.isRequired,
      member: PropTypes.object.isRequired,
      merchantReferenceCode: PropTypes.string.isRequired,
    }),
    onPaymentComplete: PropTypes.func.isRequired,
  };

  shouldComponentUpdate(nextProps) {
    return nextProps.paymentRequest.amount !== this.props.paymentRequest.amount ||
      nextProps.paymentRequest.merchantReferenceCode !== this.props.paymentRequest.merchantReferenceCode;
  }

  render() {
    const { paymentRequest, onPaymentComplete } = this.props;
    return (
      <Query
        query={getSignatureQuery}
        variables={{
          amount: paymentRequest.amount,
          merchantId: process.env.MERCHANT_ID,
          merchantReferenceCode: paymentRequest.merchantReferenceCode,
        }}
        fetchPolicy="network-only"
      >
        {({ loading, error, data }) => {
          if (loading) {
            return <Loader />;
          }
          if (error) {
            return <Message negative>Something unexpected happened!</Message>;
          }
          const signature = data.signature.value;
          const paymentRequestWithSignature = { ...paymentRequest, signature };
          return (
            <PaymentRequestFrame
              paymentRequest={paymentRequestWithSignature}
              onPaymentComplete={onPaymentComplete}
            />
          );
        }}
      </Query>
    );
  }
}

export default withAuth(PaymentContainer);



// WEBPACK FOOTER //
// ./src/app/containers/Payment/index.js